module.exports = __webpack_public_path__ + "static/media/FCA.46335efc.svg";